import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { toggleHiddenPreview, toggleIncludeSpace } from "common/actions";
import ToggleButton from "components/ToggleButton";

class ModalSetting extends React.Component<{
  setting: any;
  toggleHiddenPreview: () => void;
  toggleIncludeSpace: () => void;
  onClose: () => void;
}> {
  render() {
    const { toggleHiddenPreview, toggleIncludeSpace } = this.props;
    const { isHiddenPreview, isNotIncludeSpace } = this.props.setting;
    return (
      <Wrapper>
        <div className="content">
          <h2 className="title">設定一覧</h2>
          <div className="btnColumns">
            <div className="btnColumn">
              <p className="btnColumn_text">メモ一覧でタイトルのみ表示</p>
              <ToggleButton
                state={isHiddenPreview}
                onClick={() => toggleHiddenPreview()}
                isShowText={false}
              />
            </div>
            <div className="btnColumn">
              <p className="btnColumn_text">
                文字数カウントに改行・スペースを含めない
              </p>
              <ToggleButton
                state={isNotIncludeSpace}
                onClick={() => toggleIncludeSpace()}
                isShowText={false}
              />
            </div>
          </div>
          <button className="close" onClick={() => this.props.onClose()}>
            閉じる
          </button>
        </div>
      </Wrapper>
    );
  }
}

export default connect(({ setting }) => ({ setting }), {
  toggleHiddenPreview,
  toggleIncludeSpace
})(ModalSetting);

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);

  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }

  .content {
    background-color: #fff;
    width: 400px;
    margin: 32px auto;
    text-align: center;
    padding: 32px;
    box-sizing: border-box;
    border-radius: 8px;
  }
  .title {
    font-size: 20px;
  }

  .btnColumns {
    margin: 24px 0 12px;
  }

  .btnColumn {
    display: flex;
    padding: 16px 8px;
    justify-content: space-between;
    .btnColumn_text {
      text-align: left;
    }
    &:not(:last-child) {
      border-bottom: solid #ccc 1px;
    }
  }

  .close {
    background-color: #ddd;
    padding: 8px 16px;
    border-radius: 4px;
  }
`;
